var _ellipse, _path, _path2, _ellipse2, _ellipse3, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailPopup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 104,
    viewBox: "0 0 124 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.1962,
    cy: 52,
    rx: 51.8301,
    ry: 52,
    fill: "#E1F0EE",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6137 65.7545C29.6115 65.2876 30.7976 65.7208 31.2629 66.7218C31.7282 67.7229 31.2965 68.9129 30.2987 69.3797L23.0719 72.7606C22.0741 73.2274 20.888 72.7943 20.4227 71.7933C19.9574 70.7922 20.3891 69.6022 21.3869 69.1354L28.6137 65.7545Z",
    fill: "#C0E3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3344 72.0375C29.7997 73.0386 29.368 74.2286 28.3702 74.6954C27.3724 75.1622 26.1863 74.7291 25.7211 73.728L22.3512 66.4775C21.8859 65.4765 22.3176 64.2865 23.3154 63.8197C24.3132 63.3529 25.4993 63.786 25.9645 64.7871L29.3344 72.0375Z",
    fill: "#C0E3E0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.02,
    cy: 18.8002,
    rx: 3.58823,
    ry: 3.6,
    stroke: "#C0E3E0",
    strokeWidth: 5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.7713,
    cy: 33.6002,
    rx: 6.37909,
    ry: 6.4,
    stroke: "#C0E3E0",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5457 39.0348C39.3958 34.7265 42.7668 31.1115 47.0751 30.9605L66.9125 30.2655C71.2206 30.1146 74.8346 33.4845 74.9849 37.7927L75.6814 57.7651C75.8317 62.0737 72.4606 65.689 68.1521 65.84L48.3133 66.535C44.005 66.686 40.3909 63.3157 40.2409 59.0073L39.5457 39.0348Z",
    fill: "white",
    stroke: "#BECBE0",
    strokeWidth: 5.2038
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0757 45.7374C50.3793 41.7031 53.8852 38.6796 57.9064 38.9842L88.85 41.3286C92.8712 41.6333 95.8848 45.1507 95.5811 49.185L93.9603 70.7187C93.6566 74.753 90.1507 77.7765 86.1296 77.4719L55.1859 75.1275C51.1648 74.8228 48.1512 71.3054 48.4549 67.2711L50.0757 45.7374Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5998 39.1125C54.6434 38.737 50.3231 42.4507 49.95 47.4072L48.5805 65.6013C48.2075 70.5578 51.923 74.8803 56.8793 75.2558L84.4362 77.3436C89.3925 77.7191 93.7129 74.0054 94.086 69.0489L95.4554 50.8549C95.8285 45.8983 92.113 41.5758 87.1566 41.2003L59.5998 39.1125ZM59.8863 47.4292C59.1626 46.6658 57.9591 46.6355 57.1981 47.3616C56.4372 48.0877 56.407 49.2952 57.1307 50.0586L71.7809 65.513L87.9908 52.3708C88.8076 51.7086 88.9347 50.5074 88.2746 49.688C87.6146 48.8685 86.4173 48.741 85.6006 49.4033L72.1191 60.3334L59.8863 47.4292Z",
    fill: "#007E73",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPopup);
export default __webpack_public_path__ + "static/media/email-popup.872d7b5bf08cf6991c3d6f517f13bfe0.svg";
export { ForwardRef as ReactComponent };